import { Routes } from '@angular/router';
import { adminGuard } from '../../core/guards';

export const exerciseTemplatesRoutes: Routes = [
  {
    path: 'sports/:sportId/exercise-templates',
    canActivate: [adminGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./components/list/exercise-template-list.component').then(
            (m) => m.ExerciseTemplateListComponent,
          ),
      },
      {
        path: 'new',
        loadComponent: () =>
          import('./pages/edit/exercise-template-edit.component').then(
            (m) => m.ExerciseTemplateEditComponent,
          ),
      },
      {
        path: ':id/edit',
        loadComponent: () =>
          import('./pages/edit/exercise-template-edit.component').then(
            (m) => m.ExerciseTemplateEditComponent,
          ),
      },
    ],
  },
];
